var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./HeroVideo.scss";
var HeroVideo = function (_a) {
    var source = _a.source, _b = _a.type, type = _b === void 0 ? "video/mp4" : _b;
    return (_jsx("div", __assign({ "data-testid": "hero-video-container", className: "hero-video-container" }, { children: _jsx("video", __assign({ id: "hero-video", playsInline: true, muted: true, autoPlay: true, loop: true, controls: false }, { children: _jsx("source", { src: source, type: type }) })) })));
};
export default HeroVideo;
